import { render, staticRenderFns } from "./ProductImagePanel.vue?vue&type=template&id=2c45af38&scoped=true&"
import script from "./ProductImagePanel.vue?vue&type=script&lang=js&"
export * from "./ProductImagePanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductImagePanel.vue?vue&type=style&index=0&id=2c45af38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45af38",
  null
  
)

export default component.exports